import MedenticAuthEntryPage from "@shared/ui/MedenticAuthEntryPage";
import { BlockStack, Box, InlineStack, Spinner, Text } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";

function LoadingPage() {
  const { t } = useTranslation();
  return (
    <MedenticAuthEntryPage
      showLocaleSwitcher={false}
      wrapperClass="auth-card-wrapper"
    >
      <Box minHeight="300" paddingBlockEnd={"1000"}>
        <InlineStack align="center" blockAlign="center">
          <BlockStack gap={"400"} align="center" inlineAlign="center">
            <Spinner />
            <Text variant="bodyMd" as="h1">
              {t("common.loadingMessage")}
            </Text>
          </BlockStack>
        </InlineStack>
      </Box>
    </MedenticAuthEntryPage>
  );
}

export default LoadingPage;
